import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json; charset=utf-8',    
    })    
};

@Injectable()
export class PhotoauthService {

    constructor(private http: HttpClient) { }

    photosave(rootUrl:string, usercode: string, assessor_id:number, exam_id: number, files:any):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/uploadbase64', {usercode: usercode, assessor_id:assessor_id, exam_id:exam_id, file:files}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    
    geoLocation(rootUrl:string, assessor_id:number, exam_id: number, req_by:string, ip_address:string, city:string, region:string, postal:string, loc:string, country:string):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/geolocation', {assessor_id:assessor_id, exam_id:exam_id, req_by:req_by, ip_address:ip_address, city:city, region:region, postal:postal, loc:loc,country:country}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
}